'use client'

import React from 'react';
import Image from 'next/image';
import './about-us.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faGamepad, faTrophy, faUsers, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import GlassCard from '@/components/shared/GlassCard';

const team = [
  {
    name: 'Prateek Jain',
    photo: 'https://avatars.slack-edge.com/2025-04-23/8800199698690_060e450836e3ffcbaf2d_original.jpg',
    linkedin: 'https://www.linkedin.com/in/prateekjain87/',
  },
  {
    name: 'Swarad Mokal',
    photo: 'https://avatars.slack-edge.com/2025-12-19/10169695584129_3152c76309189c39796c_original.jpg',
    linkedin: 'https://www.linkedin.com/in/swarad/',
  },
];

const features = [
  { icon: faGamepad, title: 'Predict', desc: 'Pick the winning team for every IPL match' },
  { icon: faBolt, title: 'Bonus', desc: 'Answer a bonus question each match for extra points' },
  { icon: faTrophy, title: 'Compete', desc: 'Climb the leaderboard and track your accuracy' },
  { icon: faUsers, title: 'Community', desc: 'Built exclusively for cricket fans at Axelerant' },
];

const AboutUs = () => {
  return (
    <div className="about">
      {/* Hero */}
      <GlassCard variant="elevated" className="about__hero">
        <h2 className="about__title">Axelerant Prediction Pro</h2>
        <p className="about__tagline">The ultimate cricket prediction game for Axelerant</p>
      </GlassCard>

      {/* Features grid */}
      <div className="about__features">
        {features.map((f, i) => (
          <GlassCard key={i} variant="subtle" className="about__feature">
            <div className="about__feature-icon">
              <FontAwesomeIcon icon={f.icon} />
            </div>
            <h3 className="about__feature-title">{f.title}</h3>
            <p className="about__feature-desc">{f.desc}</p>
          </GlassCard>
        ))}
      </div>

      {/* Description */}
      <GlassCard className="about__description">
        <p>IPL Prediction Pro is a Slack Bot that lets Axelerant team members predict match winners and answer bonus questions during the Indian Premier League season. Points are awarded for correct predictions, and the leaderboard tracks performance in real-time.</p>
        <p>Built with Next.js, Supabase, and the Slack API — this dashboard displays live leaderboards, match schedules, individual prediction history, and detailed analytics for every match of the tournament.</p>
        <p className="about__disclaimer">All IPL team names, logos, and brand assets belong to their respective owners — we take no credit for them. This is a non-commercial, internal fan project for Axelerant team members and is not affiliated with, endorsed by, or sponsored by the BCCI, IPL, or any participating franchise.</p>
      </GlassCard>

      {/* Team */}
      <h2 className="about__section-title">The Team</h2>
      <div className="about__team">
        {team.map((member, i) => (
          <a
            key={i}
            href={member.linkedin}
            target="_blank"
            rel="noreferrer"
            className="about__member-link"
          >
            <GlassCard variant="subtle" className="about__member">
              <div className="about__member-photo">
                <Image
                  alt={member.name}
                  src={member.photo}
                  width={100}
                  height={100}
                  loading="lazy"
                  style={{ objectFit: 'cover', borderRadius: '50%' }}
                />
              </div>
              <div className="about__member-info">
                <h3 className="about__member-name">{member.name}</h3>
                <span className="about__member-role">{member.role}</span>
              </div>
              <div className="about__member-linkedin">
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </div>
            </GlassCard>
          </a>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
